<template>
  <div class="hot-wrapper">
    <div class="hot-tab">
      <ul>
        <li
          v-for="(item, index) in tab"
          :key="index"
          :uigs="'tab_' + index"
          :class="{ cur: item.checked }"
          @click="aClick(item, index)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <ul class="hot-list">
      <li
        v-for="(item, index) in list"
        :key="index"
        :uigs="'in_search_hotword_' + item.name"
      >
        <a :href="item.url">{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    hotList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      spver: +this.$route.query.spver === 1 ? 1 : '',
      tab: [
        {
          name: '热搜',
          checked: true,
          type: 'hot',
          list: this.hotList,
        },
        {
          name: '电影',
          checked: false,
          type: 'film',
          list: [],
        },
        {
          name: '电视剧',
          checked: false,
          type: 'teleplay',
          list: [],
        },
        {
          name: '综艺',
          checked: false,
          type: 'tvshow',
          list: [],
        },
        {
          name: '动漫',
          checked: false,
          type: 'cartoon',
          list: [],
        },
        {
          name: '纪录片',
          checked: false,
          type: 'record',
          list: [],
        },
      ],
      list: [],
    };
  },
  created() {
    if (this.hotList) {
      this.list = [...this.hotList];
    }
  },
  methods: {
    async aClick(item, index) {
      this.tab.forEach((tab, key) => {
        if (tab === item) {
          this.tab[key].checked = true;
        } else {
          this.tab[key].checked = false;
        }
      });

      if (item.list.length === 0) {
        this.tab[index].list = await this.getData(item.type);
      }

      this.list = item.list;
    },
    request(url, params = {}) {
      return axios
        .get(url, {
          params,
          timeout: 2000,
        })
        .then(res => res.data)
        .catch((err) => {
          console.log(err);
        });
    },
    async getData(type) {
      if (type === 'hot') {
        return this.hotList;
      }
      const list = [];
      const params = {
        req: 'list',
        start: 0,
        len: 10,
        entity: type,
        ipad: 1,
      };
      let res;
      if (type === 'record') {
        const params = {
          entity: 'documentary',
          class: 1,
          fr: 'filter',
          len: 10,
          req: 'list',
        };
        const rs = await this.request('/napi/video/re', params);
        if (!rs || !rs.data || rs.data.results.length === 0) {
          return list;
        }
        res = rs.data.results;
      } else {
        try {
          let ret = await this.request('/napi/video/element', params);
          ret = ret.data || {};
          if (!ret || !ret.results || ret.results.length === 0) {
            return list;
          }
          res = ret.results;
        } catch (e) {
          console.log(e);
        }
      }
      for (const item of res) {
        list.push({
          name: item.name,
          url: `/v?query=${encodeURIComponent(item.name)}&ie=utf8${this.spver === 1 ? '&spver=1' : ''}`,
        });
      }
      return list;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
.hot-wrapper {
  margin: 5px;
  padding: 0 14px;
}

.hot-tab {
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  white-space: nowrap;
  li {
    display: inline-block;
    height: 27px;
    margin-left: 20px;
    position: relative;
    color: #555;
    font-size: 15px;
    line-height: 25px;

    &.cur {
      color: #222;
      font-weight: bold;

      &:after {
        content: '';
        @extend %-horizontal-center;
        bottom: 0;
        background: #000;
        width: 20px;
        height: 2px;
        border-radius: 1px;
      }
    }

    &:first-child {
      margin-left: 0;
    }
  }
}

.hot-list {
  margin-top: 15px;

  li {
    width: 50%;
    float: left;
    margin-bottom: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    counter-increment: rank-best;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &:before {
      content: counter(rank-best);
      display: block;
      color: #cccccc;
      width: 17px;
      margin-right: 4px;
      font-weight: bold;
      flex: none;
    }

    &:first-child:before {
      color: #fa4b0c;
    }
    &:nth-of-type(2):before {
      color: #ff7c24;
    }
    &:nth-of-type(3):before {
      color: #ffa100;
    }

    a {
      color: #222;
      @include line-clip(1);
      flex: auto;
    }
  }
}
</style>
